export enum Constants{
    SIZE_OPTION_LABEL = "size",
    PRINT_MODE_OPTION_LABEL = "framing",
    FRAME_OPTION_LABEL = "border-select",
}